module.exports = __webpack_public_path__ + "static/media/realtalk_sd_jin82fe62ce7af1f2c4ffdf783f955a9509.webp";